export function Home() {
  return (
    <svg
      role="img"
      fill="#ffffff"
      height="24"
      width="24"
      className="Svg-sc-1bi12j5-0 EQkJl home-active-icon"
      viewBox="0 0 24 24"
    >
      <path d="M13.5 1.515a3 3 0 00-3 0L3 5.845a2 2 0 00-1 1.732V21a1 1 0 001 1h6a1 1 0 001-1v-6h4v6a1 1 0 001 1h6a1 1 0 001-1V7.577a2 2 0 00-1-1.732l-7.5-4.33z"></path>
    </svg>
  );
}

export function Search() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="24"
      height="24"
      viewBox="0 0 30 30"
      fill="#000000"
    >
      <path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z"></path>
    </svg>
  );
}

export function YLibrary() {
  return (
    <svg
      role="img"
      height="24"
      width="24"
      fill="#ffffff"
      className="Svg-sc-1bi12j5-0 EQkJl collection-icon"
      viewBox="0 0 24 24"
    >
      <path d="M14.5 2.134a1 1 0 011 0l6 3.464a1 1 0 01.5.866V21a1 1 0 01-1 1h-6a1 1 0 01-1-1V3a1 1 0 01.5-.866zM16 4.732V20h4V7.041l-4-2.309zM3 22a1 1 0 01-1-1V3a1 1 0 012 0v18a1 1 0 01-1 1zm6 0a1 1 0 01-1-1V3a1 1 0 012 0v18a1 1 0 01-1 1z"></path>
    </svg>
  );
}

export function Create() {
  return (
    <svg
      role="img"
      height="12"
      width="12"
      fill="#ffffff"
      aria-hidden="true"
      viewBox="0 0 16 16"
      className="Svg-sc-1bi12j5-0 EQkJl"
    >
      <path d="M15.25 8a.75.75 0 01-.75.75H8.75v5.75a.75.75 0 01-1.5 0V8.75H1.5a.75.75 0 010-1.5h5.75V1.5a.75.75 0 011.5 0v5.75h5.75a.75.75 0 01.75.75z"></path>
    </svg>
  );
}

export function Next() {
  return (
    <svg
      role="img"
      height="24"
      width="24"
      fill="#ffffff"
      className="Svg-sc-1bi12j5-0 eENWnB IYDlXmBmmUKHveMzIPCF"
      viewBox="0 0 24 24"
    >
      <path d="M8.043 2.793a1 1 0 000 1.414L15.836 12l-7.793 7.793a1 1 0 101.414 1.414L18.664 12 9.457 2.793a1 1 0 00-1.414 0z"></path>
    </svg>
  );
}

export function Previous() {
  return (
    <svg
      role="img"
      height="24"
      width="24"
      fill="#ffffff"
      className="Svg-sc-1bi12j5-0 eENWnB IYDlXmBmmUKHveMzIPCF"
      viewBox="0 0 24 24"
    >
      <path d="M15.957 2.793a1 1 0 010 1.414L8.164 12l7.793 7.793a1 1 0 11-1.414 1.414L5.336 12l9.207-9.207a1 1 0 011.414 0z"></path>
    </svg>
  );
}
export function Pause() {
  return (
    <svg
      role="img"
      height="16"
      width="16"
      viewBox="0 0 16 16"
      class="Svg-sc-1bi12j5-0 EQkJl"
    >
      <path d="M3 1.713a.7.7 0 011.05-.607l10.89 6.288a.7.7 0 010 1.212L4.05 14.894A.7.7 0 013 14.288V1.713z"></path>
    </svg>
  );
}

export function PauseAtAlbum() {
    return <svg role="img" height="24" width="24" viewBox="0 0 16 16" class="Svg-sc-1bi12j5-0 EQkJl"><path d="M3 1.713a.7.7 0 011.05-.607l10.89 6.288a.7.7 0 010 1.212L4.05 14.894A.7.7 0 013 14.288V1.713z"></path></svg>
}

export function Play(){
    return <svg role="img" height="16" width="16" viewBox="0 0 16 16" class="Svg-sc-1bi12j5-0 EQkJl"><path d="M2.7 1a.7.7 0 00-.7.7v12.6a.7.7 0 00.7.7h2.6a.7.7 0 00.7-.7V1.7a.7.7 0 00-.7-.7H2.7zm8 0a.7.7 0 00-.7.7v12.6a.7.7 0 00.7.7h2.6a.7.7 0 00.7-.7V1.7a.7.7 0 00-.7-.7h-2.6z"></path></svg>
}

export function PlayAtAlbum(){
    return <svg role="img" height="24" width="24" viewBox="0 0 16 16" class="Svg-sc-1bi12j5-0 EQkJl"><path d="M2.7 1a.7.7 0 00-.7.7v12.6a.7.7 0 00.7.7h2.6a.7.7 0 00.7-.7V1.7a.7.7 0 00-.7-.7H2.7zm8 0a.7.7 0 00-.7.7v12.6a.7.7 0 00.7.7h2.6a.7.7 0 00.7-.7V1.7a.7.7 0 00-.7-.7h-2.6z"></path></svg>
}

export function Shuffle(){
    return <svg role="img" height="16" width="16" fill="#ffffff" viewBox="0 0 16 16" class="Svg-sc-1bi12j5-0 EQkJl"><path d="M13.151.922a.75.75 0 10-1.06 1.06L13.109 3H11.16a3.75 3.75 0 00-2.873 1.34l-6.173 7.356A2.25 2.25 0 01.39 12.5H0V14h.391a3.75 3.75 0 002.873-1.34l6.173-7.356a2.25 2.25 0 011.724-.804h1.947l-1.017 1.018a.75.75 0 001.06 1.06L15.98 3.75 13.15.922zM.391 3.5H0V2h.391c1.109 0 2.16.49 2.873 1.34L4.89 5.277l-.979 1.167-1.796-2.14A2.25 2.25 0 00.39 3.5z"></path><path d="M7.5 10.723l.98-1.167.957 1.14a2.25 2.25 0 001.724.804h1.947l-1.017-1.018a.75.75 0 111.06-1.06l2.829 2.828-2.829 2.828a.75.75 0 11-1.06-1.06L13.109 13H11.16a3.75 3.75 0 01-2.873-1.34l-.787-.938z"></path></svg>
}



export function PreviousSong() {
  return (
    <svg
      role="img"
      height="16"
      width="16"
      fill="#ffffff"
      viewBox="0 0 16 16"
      class="Svg-sc-1bi12j5-0 EQkJl"
    >
      <path d="M3.3 1a.7.7 0 01.7.7v5.15l9.95-5.744a.7.7 0 011.05.606v12.575a.7.7 0 01-1.05.607L4 9.149V14.3a.7.7 0 01-.7.7H1.7a.7.7 0 01-.7-.7V1.7a.7.7 0 01.7-.7h1.6z"></path>
    </svg>
  );
}

export function NextSong() {
  return (
    <svg
      role="img"
      height="16"
      width="16"
      fill="#ffffff"
      viewBox="0 0 16 16"
      class="Svg-sc-1bi12j5-0 EQkJl"
    >
      <path d="M12.7 1a.7.7 0 00-.7.7v5.15L2.05 1.107A.7.7 0 001 1.712v12.575a.7.7 0 001.05.607L12 9.149V14.3a.7.7 0 00.7.7h1.6a.7.7 0 00.7-.7V1.7a.7.7 0 00-.7-.7h-1.6z"></path>
    </svg>
  );
}

export function Loop() {
  return (
    <svg
      role="img"
      height="16"
      width="16"
      fill="#ffffff"
      viewBox="0 0 16 16"
      class="Svg-sc-1bi12j5-0 EQkJl"
    >
      <path d="M0 4.75A3.75 3.75 0 013.75 1h.75v1.5h-.75A2.25 2.25 0 001.5 4.75v5A2.25 2.25 0 003.75 12H5v1.5H3.75A3.75 3.75 0 010 9.75v-5zM12.25 2.5h-.75V1h.75A3.75 3.75 0 0116 4.75v5a3.75 3.75 0 01-3.75 3.75H9.81l1.018 1.018a.75.75 0 11-1.06 1.06L6.939 12.75l2.829-2.828a.75.75 0 111.06 1.06L9.811 12h2.439a2.25 2.25 0 002.25-2.25v-5a2.25 2.25 0 00-2.25-2.25z"></path>
      <path d="M9.12 8V1H7.787c-.128.72-.76 1.293-1.787 1.313V3.36h1.57V8h1.55z"></path>
    </svg>
  );
}

export function Lyrics() {
  return (
    <svg
      role="img"
      height="16"
      width="16"
      fill="#ffffff"
      viewBox="0 0 16 16"
      class="Svg-sc-1bi12j5-0 EQkJl"
    >
      <path d="M13.426 2.574a2.831 2.831 0 00-4.797 1.55l3.247 3.247a2.831 2.831 0 001.55-4.797zM10.5 8.118l-2.619-2.62A63303.13 63303.13 0 004.74 9.075L2.065 12.12a1.287 1.287 0 001.816 1.816l3.06-2.688 3.56-3.129zM7.12 4.094a4.331 4.331 0 114.786 4.786l-3.974 3.493-3.06 2.689a2.787 2.787 0 01-3.933-3.933l2.676-3.045 3.505-3.99z"></path>
    </svg>
  );
}

export function Queue() {
  return (
    <svg
      role="img"
      height="16"
      width="16"
      fill="#ffffff"
      viewBox="0 0 16 16"
      class="Svg-sc-1bi12j5-0 EQkJl"
    >
      <path d="M15 15H1v-1.5h14V15zm0-4.5H1V9h14v1.5zm-14-7A2.5 2.5 0 013.5 1h9a2.5 2.5 0 010 5h-9A2.5 2.5 0 011 3.5zm2.5-1a1 1 0 000 2h9a1 1 0 100-2h-9z"></path>
    </svg>
  );
}

export function ConnectDevice() {
  return (
    <svg
      role="img"
      height="16"
      width="16"
      fill="#ffffff"
      class="Svg-sc-1bi12j5-0 EQkJl"
      aria-label="Connect to a device"
      viewBox="0 0 16 16"
    >
      <path d="M6 2.75C6 1.784 6.784 1 7.75 1h6.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0114.25 15h-6.5A1.75 1.75 0 016 13.25V2.75zm1.75-.25a.25.25 0 00-.25.25v10.5c0 .138.112.25.25.25h6.5a.25.25 0 00.25-.25V2.75a.25.25 0 00-.25-.25h-6.5zm-6 0a.25.25 0 00-.25.25v6.5c0 .138.112.25.25.25H4V11H1.75A1.75 1.75 0 010 9.25v-6.5C0 1.784.784 1 1.75 1H4v1.5H1.75zM4 15H2v-1.5h2V15z"></path>
      <path d="M13 10a2 2 0 11-4 0 2 2 0 014 0zm-1-5a1 1 0 11-2 0 1 1 0 012 0z"></path>
    </svg>
  );
}

export function Volume() {
  return (
    <svg
      role="presentation"
      height="16"
      fill="#ffffff"
      width="16"
      aria-label="Volume medium"
      id="volume-icon"
      viewBox="0 0 16 16"
      class="Svg-sc-1bi12j5-0 EQkJl"
    >
      <path d="M9.741.85a.75.75 0 01.375.65v13a.75.75 0 01-1.125.65l-6.925-4a3.642 3.642 0 01-1.33-4.967 3.639 3.639 0 011.33-1.332l6.925-4a.75.75 0 01.75 0zm-6.924 5.3a2.139 2.139 0 000 3.7l5.8 3.35V2.8l-5.8 3.35zm8.683 6.087a4.502 4.502 0 000-8.474v1.65a2.999 2.999 0 010 5.175v1.649z"></path>
    </svg>
  );
}


export function Reward(){
    return(
        <svg viewBox="0 0 64 64" width="40px" height="40px"><g data-name="Color copy"><path fill="#f9e109" d="M58,48.5V25a1,1,0,0,0-2,0V48.5A1.5,1.5,0,0,1,54.5,50,3.5,3.5,0,0,0,51,53.5V60a1,1,0,0,0,2,0V53.5A1.5,1.5,0,0,1,54.5,52,3.5,3.5,0,0,0,58,48.5Z"/><path fill="#f9e109" d="M58,55a3,3,0,1,0,3,3A3,3,0,0,0,58,55Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,58,59Z"/><path fill="#f9e109" d="M53,30a3,3,0,1,0-3,3A3,3,0,0,0,53,30Zm-4,0a1,1,0,1,1,1,1A1,1,0,0,1,49,30Z"/><path fill="#f9e109" d="M9,45a3,3,0,1,0-3,3A3,3,0,0,0,9,45ZM5,45a1,1,0,1,1,1,1A1,1,0,0,1,5,45Z"/><path fill="#f9e109" d="M6,9A3,3,0,1,0,3,6,3,3,0,0,0,6,9ZM6,5A1,1,0,1,1,5,6,1,1,0,0,1,6,5Z"/><path fill="#f9e109" d="M52.012,46.32a1,1,0,0,0,1.414-1.414l-.707-.707.707-.707a1,1,0,1,0-1.414-1.414l-.707.707-.707-.707a1,1,0,1,0-1.414,1.414l.707.707-.707.707A1,1,0,1,0,50.6,46.32l.707-.707Z"/><path fill="#f9e109" d="M16.426,32.078a1,1,0,0,0-1.414,0l-.707.707-.707-.707a1,1,0,1,0-1.414,1.414l.707.707-.707.707A1,1,0,1,0,13.6,36.32l.707-.707.707.707a1,1,0,0,0,1.414-1.414l-.707-.707.707-.707A1,1,0,0,0,16.426,32.078Z"/><path fill="#f9e109" d="M48,11.9a1.006,1.006,0,0,0,.5-.133l3.122-1.8a1,1,0,1,0-1-1.733l-3.122,1.8A1,1,0,0,0,48,11.9Z"/><path fill="#f9e109" d="M49,15a1,1,0,0,0,1,1h3a1,1,0,0,0,0-2H50A1,1,0,0,0,49,15Z"/><path fill="#f9e109" d="M46.447,4.105a1,1,0,0,0-1.342.448l-1,2a1,1,0,0,0,1.79.894l1-2A1,1,0,0,0,46.447,4.105Z"/><path fill="#f9e109" d="M13.366,40.475,7.715,36.842a3,3,0,0,1-.5-4.644l3.32-3.32A4.966,4.966,0,0,0,12,25.343V15a1,1,0,0,0-2,0V25.343a3.02,3.02,0,0,1-.878,2.121L5.8,30.784a5,5,0,0,0,.832,7.741l5.651,3.633a3,3,0,0,1,.5,4.644l-5.32,5.32A4.966,4.966,0,0,0,6,55.657V60a1,1,0,0,0,2,0V55.657a3.02,3.02,0,0,1,.878-2.121l5.32-5.32a5,5,0,0,0-.832-7.741Z"/><rect width="20" height="12" x="22" y="45" fill="#f9e109"/><path fill="#fcbc04" d="M37,54a11.994,11.994,0,0,1-11.607-9H22V57H42V54Z"/><polygon fill="#fcbc04" points="37 53 26 54 27 49 36 50 37 53"/><polygon fill="#fcbc04" points="35 41 29 41 29 29 35 31 35 41"/><polygon fill="#e59730" points="29 29 29 35 33 39 29 39 29 41 35 41 35 31 29 29"/><rect width="10" height="12" x="22.546" y="17.16" fill="#f9e109" transform="rotate(-30 27.546 23.16)"/><polygon fill="#84d2f4" points="21.751 31.124 26.215 30.856 20.215 20.464 17.751 24.196 21.751 31.124"/><path fill="#84d2f4" d="M28.876,15.464h0l6,10.392h0A25.419,25.419,0,0,1,46.061,22.5L49,22.321,39,5,37.378,7.457A25.416,25.416,0,0,1,28.876,15.464Z"/><path fill="#84d2f4" d="M38.621,37.551h0a3.07,3.07,0,0,1-3.741-.525l-6.933-7.17,4.331-2.5,6.671,5.1A3.069,3.069,0,0,1,38.621,37.551Z"/><rect width="10" height="4" x="22.546" y="21.16" fill="#c4f236" transform="rotate(-30 27.546 23.16)"/><path fill="#57b7eb" d="M41.536,17.392a8,8,0,0,1-10.928-2.928l-.045-.077c-.549.378-1.108.743-1.687,1.077l6,10.392A25.419,25.419,0,0,1,46.061,22.5L49,22.321l-4-6.929Z"/><path fill="#57b7eb" d="M35.521,34.549a3.9,3.9,0,0,1-.361-4.99l-2.882-2.2-4.331,2.5,6.933,7.17a3.062,3.062,0,0,0,3.6.588Z"/><path fill="#fcbc04" d="M27.144,16.464l4.5,7.794a6,6,0,0,1-8.2-2.2l-1.5-2.6-1.732,1,6,10.392,8.661-5-6-10.392Z"/><path fill="#a1d51c" d="M24.025,22.883l-1.81,1.045,2,3.464,4.059-2.343A5.994,5.994,0,0,1,24.025,22.883Z"/><rect width="2" height="4" x="30.01" y="19.16" fill="#a1d51c" transform="rotate(-30 31.01 21.161)"/><path fill="#57b7eb" d="M18.983,22.33l2,3.464a2.988,2.988,0,0,1-.324,3.439l1.092,1.891,4.464-.268-6-10.392Z"/><polygon fill="#f9e109" points="29 3 30.625 6.292 34.257 6.82 31.629 9.382 32.249 13 29 11.292 25.751 13 26.371 9.382 23.743 6.82 27.375 6.292 29 3"/><path fill="#f9e109" d="M17,57H47a2,2,0,0,1,2,2v2a0,0,0,0,1,0,0H15a0,0,0,0,1,0,0V59A2,2,0,0,1,17,57Z"/><rect width="11" height="4" x="26.5" y="41" fill="#f9e109"/><rect width="10" height="4" x="27" y="49" fill="#84d2f4"/><path fill="#fcbc04" d="M31,43a2,2,0,0,1-2-2H26.5v4h11V43Z"/><path fill="#57b7eb" d="M31,51a2.99,2.99,0,0,1-2.816-2H27v4H37V51Z"/><path fill="#4891d3" d="M27.279,49H27v4h5.214A12.011,12.011,0,0,1,27.279,49Z"/><path fill="#fcbc04" d="M18,57H17a2,2,0,0,0-2,2v2H49V59H20A2,2,0,0,1,18,57Z"/><path fill="#fcbc04" d="M32.25,13,29,11.29,25.75,13l.62-3.62L23.74,6.82l2.78-.41a1.31,1.31,0,0,0,.31.44,1.437,1.437,0,0,1,.43,1.03,2.105,2.105,0,0,1-.02.25,1.442,1.442,0,0,0,1.42,1.68,1.39,1.39,0,0,0,.67-.17,1.483,1.483,0,0,1,1.34,0,1.371,1.371,0,0,0,1.02.12Z"/><polygon fill="#f9e109" points="60 25 54 25 57 21 60 25"/><polygon fill="#f9e109" points="14 15 8 15 11 11 14 15"/></g></svg>
    )
}

export function RewardMedal(){
    return(
        <svg viewBox="0 0 256 256" width="32px" height="32px"><path fill="#939598" d="M159.535,117.494h-54.613c-4.709,0-8.527-3.818-8.527-8.527v0c0-4.709,3.818-8.527,8.527-8.527h54.613 c4.709,0,8.527,3.818,8.527,8.527v0C168.062,113.676,164.245,117.494,159.535,117.494z"/><path fill="#808285" d="M162.516,100.986c0.347,0.929,0.546,1.93,0.546,2.981c0,4.709-3.818,8.527-8.527,8.527H99.922 c-1.05,0-2.052-0.199-2.981-0.546c1.21,3.237,4.322,5.546,7.981,5.546h54.613c4.709,0,8.527-3.818,8.527-8.527 C168.062,105.308,165.753,102.196,162.516,100.986z"/><path fill="#A54AF4" d="M192.229,19.866h-120v54.855c0,3.544,1.875,6.823,4.93,8.619l29.07,17.1h52l29.07-17.1 c3.054-1.797,4.93-5.076,4.93-8.619V19.866z"/><path fill="#B171F4" d="M78.229,68.132c-1.104,0-2-0.896-2-2v-32c0-1.104,0.896-2,2-2s2,0.896,2,2v32 C80.229,67.237,79.333,68.132,78.229,68.132z M78.229,28.132c-1.104,0-2-0.896-2-2v-0.266c0-1.104,0.896-2,2-2s2,0.896,2,2v0.266 C80.229,27.237,79.333,28.132,78.229,28.132z"/><path fill="#893ADD" d="M182.229,19.866v44.855c0,3.544-1.875,6.823-4.93,8.619l-29.07,17.1h-52L72.392,76.418 c0.495,2.868,2.209,5.417,4.767,6.922l29.07,17.1h52l29.07-17.1c3.054-1.797,4.93-5.076,4.93-8.619V19.866H182.229z"/><path fill="#6C2BC1" d="M187.229,19.866v49.855c0,3.544-1.875,6.823-4.93,8.619l-29.07,17.1h-52L73.185,78.944 c0.842,1.803,2.201,3.353,3.973,4.396l29.07,17.1h52l29.07-17.1c3.054-1.797,4.93-5.076,4.93-8.619V19.866H187.229z"/><path fill="#939598" d="M198.612,19.866H65.846c-3.654,0-6.617-2.962-6.617-6.617v0c0-3.654,2.962-6.617,6.617-6.617h132.766 c3.654,0,6.617,2.962,6.617,6.617v0C205.229,16.904,202.266,19.866,198.612,19.866z"/><path fill="#808285" d="M202.179,7.682c0.661,1.03,1.05,2.252,1.05,3.567v0c0,3.654-2.962,6.617-6.617,6.617H63.846 c-1.315,0-2.537-0.388-3.567-1.05c1.177,1.832,3.228,3.05,5.567,3.05h132.767c3.654,0,6.617-2.962,6.617-6.617v0 C205.229,10.91,204.012,8.859,202.179,7.682z"/><rect width="40" height="80.574" x="112.229" y="19.866" fill="#F1F2F2"/><rect width="40" height="5" x="112.229" y="95.44" fill="#E6E7E8"/><path fill="#FFC91D" d="M192.229,210.5v-57.735c0-3.573-1.906-6.874-5-8.66l-50-28.868c-3.094-1.786-6.906-1.786-10,0l-50,28.868 c-3.094,1.786-5,5.088-5,8.66V210.5c0,3.573,1.906,6.874,5,8.66l50,28.868c3.094,1.786,6.906,1.786,10,0l50-28.868 C190.323,217.374,192.229,214.073,192.229,210.5z"/><path fill="#FFA91A" d="M187.229,144.105l-0.948-0.548c0.604,1.3,0.948,2.726,0.948,4.208V205.5c0,3.573-1.906,6.874-5,8.66 l-50,28.867c-3.094,1.786-6.906,1.786-10,0l-49.052-28.32c0.853,1.834,2.241,3.407,4.052,4.452l50,28.867 c3.094,1.786,6.906,1.786,10,0l50-28.867c3.094-1.786,5-5.088,5-8.66v-57.735C192.229,149.192,190.323,145.891,187.229,144.105z"/><path fill="#F79219" d="M178.383,202.506v-41.747c0-3.573-1.906-6.874-5-8.66l-36.154-20.873c-3.094-1.786-6.906-1.786-10,0 l-36.154,20.873c-3.094,1.786-5,5.088-5,8.66v41.747c0,3.573,1.906,6.874,5,8.66l36.154,20.873c3.094,1.786,6.906,1.786,10,0 l36.154-20.873C176.477,209.38,178.383,206.079,178.383,202.506z"/><path fill="#EF7816" d="M173.383,152.099l-0.948-0.548c0.604,1.3,0.948,2.726,0.948,4.208v41.747c0,3.573-1.906,6.874-5,8.66 l-36.154,20.873c-3.094,1.786-6.906,1.786-10,0l-35.206-20.326c0.853,1.834,2.241,3.407,4.052,4.452l36.154,20.873 c3.094,1.786,6.906,1.786,10,0l36.154-20.873c3.094-1.786,5-5.088,5-8.66v-41.747 C178.383,157.186,176.477,153.885,173.383,152.099z"/><path fill="#FFF" d="M134.131,154.375l6.088,18.736h19.701c1.937,0,2.743,2.479,1.176,3.618l-15.938,11.58l6.088,18.736 c0.599,1.843-1.51,3.375-3.078,2.236l-15.938-11.58l-15.938,11.58c-1.567,1.139-3.676-0.393-3.078-2.236l6.088-18.736 l-15.938-11.58c-1.567-1.139-0.762-3.618,1.176-3.618h19.7l6.088-18.736C130.925,152.532,133.532,152.532,134.131,154.375z"/><path fill="#FFC91D" d="M48.201,185.464l0.638,2.972c0.671,3.123,3.11,5.562,6.233,6.233l2.972,0.638 c0.717,0.154,0.717,1.176,0,1.33l-2.972,0.638c-3.123,0.671-5.562,3.11-6.233,6.233l-0.638,2.972 c-0.154,0.717-1.176,0.717-1.33,0l-0.638-2.972c-0.671-3.123-3.11-5.562-6.233-6.233l-2.972-0.638 c-0.717-0.154-0.717-1.176,0-1.33L40,194.669c3.123-0.671,5.562-3.11,6.233-6.233l0.638-2.972 C47.025,184.748,48.047,184.748,48.201,185.464z"/><path fill="#FFC91D" d="M60.974,215.742l0.935,4.355c0.983,4.576,4.557,8.15,9.133,9.133l4.355,0.935 c1.05,0.225,1.05,1.724,0,1.949l-4.355,0.935c-4.576,0.983-8.15,4.557-9.133,9.133l-0.935,4.355c-0.225,1.05-1.724,1.05-1.949,0 l-0.935-4.355c-0.983-4.576-4.557-8.15-9.133-9.133l-4.355-0.935c-1.05-0.225-1.05-1.724,0-1.949l4.355-0.935 c4.576-0.983,8.15-4.557,9.133-9.133l0.935-4.355C59.25,214.692,60.749,214.692,60.974,215.742z"/><path fill="#FFC91D" d="M206.316,120.427l0.811,3.778c0.852,3.969,3.953,7.069,7.922,7.922l3.778,0.811 c0.911,0.196,0.911,1.495,0,1.691l-3.778,0.811c-3.969,0.852-7.069,3.953-7.922,7.922l-0.811,3.778 c-0.196,0.911-1.495,0.911-1.691,0l-0.811-3.778c-0.852-3.969-3.953-7.069-7.922-7.922l-3.778-0.811 c-0.911-0.196-0.911-1.495,0-1.691l3.778-0.811c3.969-0.852,7.069-3.953,7.922-7.922l0.811-3.778 C204.821,119.517,206.12,119.517,206.316,120.427z"/></svg>
    )
}